import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { fbPixel } from '../utils/fbPixel';

export function useFbPixelPageView() {
  const location = useLocation();

  useEffect(() => {
    // Track page view on route change
    fbPixel.track('PageView');
  }, [location]);
}